<template>
    <div class="numbers row justify_between align_center">
        <slot />
    </div>
</template>